
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.193 4.724l1.274 13.1c.208 2.137 2.835 3.035 4.308 1.473l2.208-2.344a.5.5 0 01.797.093l2.514 4.355a1 1 0 001.732-1l-2.514-4.355a.5.5 0 01.318-.736l3.134-.741c2.09-.494 2.626-3.219.879-4.467L8.135 2.448c-1.746-1.248-4.15.14-3.942 2.276z"}})])
          )
        }
      }
    